export default "__VITE_ASSET__BFqwV9Z8__"